var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'signup-iframe',
    { 'with--noTransform': _vm.noTransform },
    { 'signup-iframe--isModal': _vm.isModal },
    _vm.loginSocialClass,
  ]},[_c('client-only',[(_vm.loading)?_c('div',{staticClass:"signup-iframe__placeholder"},[_c('hot-loading')],1):_vm._e(),_vm._v(" "),_c('iframe',{class:[
        { noLogo: !_vm.hasLogo },
        'signup-iframe__box',
        { 'signup-iframe__box--loading': _vm.loading },
        { 'signup-iframe__box--isModal': _vm.isModal },
      ],attrs:{"src":`https://sso.${this.hostname}/signup?variant&${this.logo}&${this.transparent}&embed${this.isTestSignupEmbedButton}${this.loginSocialFormated}&locale=${
        this.locale
      }&service=${encodeURIComponent(
        `${this.service}?isEmbed=true&element=${this.element}&url=sso.${this.hostname}/signup?variant${this.logo}&${this.checkbox}&embed${this.loginSocialFormated}&locale=${this.locale}&referrer=https://${this.hostname}${this.path}?${this.query}`
      )}`,"title":"Hotmart SignUp","frameBorder":"0","sandbox":"allow-top-navigation allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox","width":"100%","height":"100%","scrolling":"no"},on:{"load":_vm.iframeLoaded}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }